export default function unaccent(value) {
  return value ? value.normalize("NFD").replace(/[\u0300-\u036F]/g, "") : "";
}
